import LoadingSpinner from './LoadingSpinner';
import CasinoFrontSkeleton from '../home/CasinoFrontSkeleton';
import { Skeleton } from '../home/Skeleton';

function Block({ className = '' }) {
  return <Skeleton className={className} />;
}

function isCasinoGameRoute(page, casinoGameId) {
  if (casinoGameId) return true;
  const base = String(page || '');
  if (!base.startsWith('casino:')) return false;
  const detail = base.slice('casino:'.length);
  return Boolean(detail) && detail !== 'lobby';
}

export default function RouteFallback({ page, isMobile = false, casinoGameId = null }) {
  const base = String(page || '');

  if (isCasinoGameRoute(base, casinoGameId)) {
    return (
      <div className="route-fallback route-fallback--casino-game route-fallback--spinner" aria-busy="true">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (base === 'casino' || base.startsWith('casino:')) {
    return (
      <div className="route-fallback casino-page" aria-busy="true" aria-hidden="true">
        <CasinoFrontSkeleton
          columnCount={isMobile ? 3 : 7}
          cardCount={isMobile ? 9 : 21}
          isMobile={isMobile}
        />
      </div>
    );
  }

  if (base === 'sport') {
    return (
      <div className="route-fallback sport-page" aria-busy="true" aria-hidden="true">
        <div className="route-fallback__list">
          {Array.from({ length: 8 }).map((_, i) => (
            <Block key={i} className="route-fallback__line" />
          ))}
        </div>
      </div>
    );
  }

  if (base === 'account' || base.startsWith('account:')) {
    return (
      <div className="route-fallback" aria-busy="true" aria-hidden="true">
        <div className="route-fallback__list">
          {Array.from({ length: 6 }).map((_, i) => (
            <Block key={i} className="route-fallback__line" />
          ))}
        </div>
      </div>
    );
  }

  if (base === 'vip') {
    return (
      <div className="route-fallback route-fallback--vip" aria-busy="true" aria-hidden="true">
        <Block className="route-fallback__hero" />
        <div className={`route-fallback__grid route-fallback__grid--vip${isMobile ? ' route-fallback__grid--mobile' : ''}`}>
          {Array.from({ length: isMobile ? 3 : 6 }).map((_, i) => (
            <Block key={i} className="route-fallback__panel" />
          ))}
        </div>
      </div>
    );
  }

  if (base === 'promos' || base.startsWith('promos:')) {
    return (
      <div className="route-fallback" aria-busy="true" aria-hidden="true">
        <Block className="route-fallback__banner" />
        <div className={`route-fallback__grid${isMobile ? ' route-fallback__grid--mobile' : ''}`}>
          {Array.from({ length: isMobile ? 4 : 6 }).map((_, i) => (
            <Block key={i} className="route-fallback__panel" />
          ))}
        </div>
      </div>
    );
  }

  if (base === 'help' || base.startsWith('help:')) {
    return (
      <div className="route-fallback" aria-busy="true" aria-hidden="true">
        <div className="route-fallback__list">
          {Array.from({ length: 7 }).map((_, i) => (
            <Block key={i} className={`route-fallback__line${i === 0 ? ' route-fallback__line--short' : ''}`} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div
      className={`route-fallback route-fallback--home route-fallback--spinner${isMobile ? ' route-fallback--mobile' : ''}`}
      aria-busy="true"
    >
      <LoadingSpinner size="lg" />
    </div>
  );
}
